import React from "react";
import PropTypes from "prop-types";
import { Field } from "redux-form";

// Validation Rules
const required = value => (value ? undefined : "Required");

export const renderField = ({
  input,
  label,
  type,
  style,
  meta: { touched, error, warning },
}) =>
  <div>
    <input {...input} type={type} style={style} />

    {touched &&
      ((error &&
        <div className="field__error">
          {error}
        </div>) ||
        (warning &&
          <div className="field__error">
            {warning}
          </div>))}
  </div>;

const RadioButton = props => {
  let fieldValidation = [];

  if (props.column === "Emp") {
    fieldValidation = [required];
  }

  let style = {
    textAlign: "center",
  };

  if (props.optionsIndex === props.optionsLength - 1) {
    style = {
      ...style,
      borderRight: "1px solid #000",
      ...props.style,
    };
  } else {
    style = { ...style, ...props.style };
  }

  if (props.questionId) {
    return (
      <td style={style}>
        <Field
          name={props.column + props.questionId}
          type="radio"
          component={renderField}
          value={props.value}
          validate={fieldValidation}
        />
      </td>
    );
  }

  return <td style={style}>&nbsp;</td>;
};

RadioButton.propTypes = {
  value: PropTypes.string.isRequired,
  optionsIndex: PropTypes.number.isRequired,
  optionsLength: PropTypes.number.isRequired,
  column: PropTypes.string.isRequired,
  questionId: PropTypes,
  style: PropTypes.object,
};

export const RadioButtonGroupRow = props => {
  const style = { borderRight: "1px solid #000", ...props.style };

  const elements = [];
  let key = 0;

  if (props.questionInput && props.questionInput.type === "textarea") {
    elements.push(
      <td style={style} key={key}>
        <table>
          <tbody>
            <tr>
              {props.questionBullet &&
                <td style={{ width: 20 }}>
                  {props.questionBullet}
                </td>}
              <td>
                {props.questionDesc}
                <Field
                  {...props.questionInput}
                  id={
                    props.questionInput.id
                      ? props.questionInput.id
                      : props.questionInput.name
                  }
                  component="textarea"
                />
              </td>
            </tr>
          </tbody>
        </table>
      </td>
    );
  } else if (props.questionInput) {
    elements.push(
      <td style={style} key={key}>
        <table>
          <tbody>
            <tr>
              {props.questionBullet &&
                <td style={{ width: 30 }}>
                  {props.questionBullet}
                </td>}
              <td>
                {props.questionDesc}
                <Field
                  {...props.questionInput}
                  type="text"
                  id={
                    props.questionInput.id
                      ? props.questionInput.id
                      : props.questionInput.name
                  }
                  component={renderField}
                />
              </td>
            </tr>
          </tbody>
        </table>
      </td>
    );
  } else {
    const customBulletStyle = {
      width: 30,
      borderLeft: "1px solid #000",
      borderBottom: "1px solid #000",
      ...props.style,
    };
    const customQuestionDescStyle = {
      borderRight: "1px solid #000",
      borderBottom: "1px solid #000",
      ...props.style,
    };
    const bullet =
      props.questionBullet &&
      <td style={customBulletStyle}>
        {props.questionBullet}
      </td>;
    const questionDesc = (
      <td style={customQuestionDescStyle}>
        {props.questionDesc}
      </td>
    );

    props.questionBullet && elements.push(bullet);
    elements.push(questionDesc);
  }
  key += 1;

  for (let col = 0; col < props.columns.length; col++) {
    for (let opt = 0; opt < props.options.length; opt++) {
      elements.push(
        <RadioButton
          key={key}
          value={props.options[opt]}
          optionsIndex={opt}
          optionsLength={props.options.length}
          column={props.columns[col]}
          questionId={props.questionId}
          style={props.style}
        />
      );
      key += 1;
    }
  }

  return (
    <tr>
      {elements}
    </tr>
  );
};

RadioButtonGroupRow.propTypes = {
  columns: PropTypes.array.isRequired,
  options: PropTypes.array.isRequired,
  questionBullet: PropTypes.string,
  questionId: PropTypes.string,
  questionInput: PropTypes.object,
  questionDesc: PropTypes.string,
  style: PropTypes.object,
};

export const GroupTableRowField = props => {
  const { data, index } = props;
  const { id, cols } = data;

  return (
    <tr>
      {cols.map(({ name, type, label, style }, i) =>
        <td
          key={`col-${id}${i}`}
          style={{ border: "1px solid #000", textAlign: "center" }}
        >
          {type === "text" &&
            <Field
              component={renderField}
              name={`${id}${name}${index}`}
              type={type}
              label={`${id}${name}${index}`}
              style={{ ...style }}
            />}
          {type === "textarea" &&
            <Field
              component="textarea"
              multiLine
              boxed
              name={`${id}${name}${index}`}
              id={`${id}${name}${index}`}
              type={type}
              label={label}
              style={{ ...style }}
              rows={3}
              cols={40}
              defaultValue={""}
            />}
        </td>
      )}
    </tr>
  );
};

GroupTableRowField.propTypes = {
  data: PropTypes.object,
  index: PropTypes.number,
};



// WEBPACK FOOTER //
// ./components/employee/hdf-forms/Tokiomarine/components.js